import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

const customStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%'
  }),
  control: (provided) => ({
    ...provided,
    borderColor: 'rgba(203, 213, 224, 1)'
  })
}

const Select = ({ onChange, name, value, options, isLoading, placeholder, isDisabled }) => {
  
  const onChangeSelected = e => {
    onChange({
      target: {
        name,
        value: e ? e.value : ''
      }
    })
  }
  
  const selectedValue = options.find(x => `${x.value}` === `${value}`) || ''

  return (
    <ReactSelect 
      isClearable
      styles={customStyles}
      onChange={onChangeSelected}
      value={selectedValue}
      options={options}
      isLoading={isLoading}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  )
}


Select.defaultProps = {
  value: '',
  name: '',
  options: [],
  isLoading: false,
  placeholder: '-- select --',
  isDisabled: false,
}

Select.propTypes = {
  value: PropTypes.string, 
  name: PropTypes.string,
  options: PropTypes.instanceOf(Array),
  onChange: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
}

export default Select